exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1TDehnPV-Header-module-header{background-color:#000;color:#fff;height:62px;padding-top:0}._2evP0-3D-Header-module-product-name{display:inline-block;font-size:18px;font-weight:700;left:115px;position:absolute;top:5px}._1QbDGhXV-Header-module-product-attribution{display:inline-block;font-size:14px;left:115px;position:absolute;top:30px}.xLco0ITa-Header-module-nav{margin-right:30px;margin-top:20px}.xLco0ITa-Header-module-nav a,.xLco0ITa-Header-module-nav button{color:#fff;font-size:16px;margin-left:10px;margin-right:10px}.xLco0ITa-Header-module-nav button{padding:0}.xLco0ITa-Header-module-nav a:first-child,.xLco0ITa-Header-module-nav button:first-child{margin-left:0}.xLco0ITa-Header-module-nav a:last-child,.xLco0ITa-Header-module-nav button:last-child{margin-right:0}._2UZFiSad-Header-module-nav-item{margin-right:10px}._2UZFiSad-Header-module-nav-item:last-child{margin-right:0}.xLco0ITa-Header-module-nav button:hover{color:#fff}", ""]);

// exports
exports.locals = {
	"primary": "#067370",
	"header": "_1TDehnPV-Header-module-header",
	"product-name": "_2evP0-3D-Header-module-product-name",
	"productName": "_2evP0-3D-Header-module-product-name",
	"product-attribution": "_1QbDGhXV-Header-module-product-attribution",
	"productAttribution": "_1QbDGhXV-Header-module-product-attribution",
	"nav": "xLco0ITa-Header-module-nav",
	"nav-item": "_2UZFiSad-Header-module-nav-item",
	"navItem": "_2UZFiSad-Header-module-nav-item"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/Header/Header.module.scss
// module id = 1207
// module chunks = 0